import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import storage from "../../../../firebaseConfig.js"
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage"
import axios from 'axios';
import { makeStyles } from '@material-ui/styles';
import {
  Button,
  Chip,
  Collapse,
  Divider,
  Drawer,
  FormControlLabel,
  Radio,
  RadioGroup,
  Slider,
  Avatar,
  TextField,
  Card,
  Paper,
  Typography,
  Grid
} from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';
import FormGroup from '@material-ui/core/FormGroup';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {

  KeyboardDatePicker,
} from '@material-ui/pickers';
import { ToggleButton, ToggleButtonGroup } from '@material-ui/lab';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import CloseIcon from '@material-ui/icons/Close';
import DeleteIcon from '@material-ui/icons/DeleteOutlined';
import AddIcon from '@material-ui/icons/Add';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';

const useStyles = makeStyles(theme => ({
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  papercontent: {
    marginTop: theme.spacing(2),
    textAlign: 'center'
  },
  drawer: {
    width: 420,
    maxWidth: '100%'
  },
  descriptionfield: {
    width: '100%'

  },
  input: {
    display: 'none',
  },
  header: {
    padding: theme.spacing(2, 1),
    display: 'flex',
    justifyContent: 'space-between'
  },
  buttonIcon: {
    marginRight: theme.spacing(1)
  },
  content: {
    padding: theme.spacing(2, 3),
    flexGrow: 1
  },
  contentSection: {
    padding: theme.spacing(2, 0)
  },
  contentSectionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    cursor: 'pointer'
  },
  contentSectionContent: {},
  formGroup: {

    padding: theme.spacing(1, 0)
  },
  fieldGroup: {
    display: 'flex',
    alignItems: 'center'
  },
  field: {
    marginTop: 0,
    marginBottom: 0
  },
  flexGrow: {
    flexGrow: 1
  },
  addButton: {
    marginLeft: theme.spacing(1)
  },
  tags: {
    marginTop: theme.spacing(1)
  },
  minAmount: {
    marginRight: theme.spacing(3)
  },
  maxAmount: {
    marginLeft: theme.spacing(3)
  },
  card: {
    maxHeight: "100px",
    maxWidth: "100px",
    width: "100px",
    height: "100px",
    textAlign: "left",
    boxShadow: "0 1px 2px 0 rgba(60,64,67,.3), 0 1px 3px 1px rgba(60,64,67,.15)"
  },
  radioGroup: {},
  actions: {
    textAlign: 'right',
    padding: theme.spacing(3),
    paddingRight: theme.spacing(5),
    '& > * + *': {
      margin: theme.spacing(0)
    }
  }
}));

function isAllLanguage(lang) {
  return !lang || lang.name === 'All' || String(lang.id) === '0';
}

function realSurveyLanguages(list) {
  return (list || []).filter((lang) => lang && !isAllLanguage(lang));
}

function expandSurveyLanguages(selected, options) {
  const picked = selected || [];
  if (picked.some((lang) => isAllLanguage(lang))) {
    return realSurveyLanguages(options);
  }
  return realSurveyLanguages(picked);
}

const AddSurvey = props => {
  const { open, onClose, onSave, usercontent, masters, viewtype, className, ...rest } = props;

  const classes = useStyles();

  const initialValues = {
    languages: [],
    nameenglish: '',
    nametamil: '',
    nametelugu: '',
    descenglish: '',
    desctamil: '',
    desctelugu: '',
    imageurl: '',
    commodity: []
  };
  const [percent, setPercent] = React.useState(0);
  const [values, setValues] = useState({ ...initialValues });
  const [url, setUrl] = useState("");
  const setData = async (value, name, fun, state) => {
    let url = null;
    let extra = {};
    if (name === "image") {
      if (!value) {
        alert("Please choose a file first!")
      }

      const storageRef = ref(storage, `/news/${value.name}`)
      const uploadTask = uploadBytesResumable(storageRef, value);
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const percent = Math.round(
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          );

          // update progress
          setPercent(percent);
        },
        (err) => console.log(err),
        () => {
          // download url
          getDownloadURL(uploadTask.snapshot.ref).then((url) => {
            console.log("imageurl" + url)
            setValues(values => ({
              ...values,
              ['imageurl']: url
            }));
            props.onValuechange('imageurl', url)

          });
        }
      );

    }

    fun({
      ...state, [name]: value, ...extra
    })
  }
  const handleinputchange = type => e => {
    setValues({
      ...values,
      [type]: e.target.value
    });
    props.onValuechange(type, e.target.value)
  }
  async function uploadimage(imgdata) {
    // onUpdate && onUpdate(values);
    var formData = new FormData()
    formData.append('photo', imgdata)
    formData.append('reg_id', "0001")

    axios.post('http://localhost:7001/uploads', formData, {
    }).then(res => {
      setUrl(res.data.url)
      props.onValuechange("imgurl", res.data.url);
    }).catch(err => {
      // what now?
      alert(JSON.stringify(err));
    })
  };
  const handleoptionchange = type => (event, value) => {
    const next = type === 'languages'
      ? expandSurveyLanguages(value, masters.languages)
      : value;
    setValues(values => ({
      ...values,
      [type]: next
    }));
    props.onValuechange(type, next)
  }
  const handleSubmit = event => {
    event.preventDefault();
    // alert(JSON.stringify(values))
    onSave && onSave(values);
  };
  React.useEffect(() => {
    if (usercontent && usercontent.id) {
      setValues({
        ...usercontent

      })

    }
  }, [usercontent]);


  return (
    <Paper className={classes.papercontent}>
      <form
        {...rest}
        className={clsx(classes.root, className)}
        onSubmit={handleSubmit}
      >

        <div className={classes.content}>
          <Grid container xs={12} spacing={2}>
            <Grid item xs={12}>


              <Autocomplete
                multiple
                id="combo-box-demo"
                options={masters.languages}
                margin="dense"
                fullWidth
                disabled={viewtype == 2 ? true : false}
                value={values.languages}
                onChange={handleoptionchange('languages')}
                getOptionLabel={(option) => option.name || ''}
                getOptionSelected={(option, value) => option.id === value.id}
                renderInput={(params) => <TextField {...params} label={"Language"} fullWidth margin="dense" variant="outlined" />}
              />
            </Grid>

            <Grid item xs={12}>
              <Autocomplete
                multiple
                id="combo-box-demo"
                options={masters.commodity}
                margin="dense"
                fullWidth
                disabled={viewtype == 2 ? true : false}
                value={values.commodity}
                onChange={handleoptionchange('commodity')}
                getOptionLabel={(option) => option.name}
                renderInput={(params) => <TextField {...params} label={"Commodity"} fullWidth margin="dense" variant="outlined" />}
              />

            </Grid>
            {values.languages.map((lang, index) => (
              <>
                <Grid item xs={12}>
                  <TextareaAutosize
                    className={classes.descriptionfield}
                    rowsMin={4}
                    rowsMax={4}
                    aria-label="maximum height"
                    placeholder={`Question ( ${lang.name} *)`}
                    value={values[`${lang.name}`]}
                    onChange={handleinputchange(`${lang.name}`)}
                    defaultValue=""
                  />
                </Grid> </>
            ))

            }
            <Grid item xs={12}>
              {(masters?.surveyType?.length > 0 && usercontent.id && values?.surveytype?.value) && <Autocomplete
                id="combo-box-demo"
                options={masters?.surveyType??[]}
                margin="dense"
                fullWidth
                disabled={viewtype == 2 ? true : false}
                value={values.surveytype && values.surveytype}
                defaultValue={values.surveytype}
                getOptionLabel={(option) => option.name}
                onChange={handleoptionchange('surveytype')}
                renderInput={(params) => <TextField {...params} label={"Survey Type"} fullWidth margin="dense" variant="outlined" />}
              />}
              {(masters?.surveyType?.length > 0 && !usercontent.id) && <Autocomplete
                id="combo-box-demo"
                options={masters?.surveyType??[]}
                margin="dense"
                fullWidth
                disabled={viewtype == 2 ? true : false}
                value={values.surveytype && values.surveytype}
                defaultValue={values.surveytype}
                getOptionLabel={(option) => option.name}
                onChange={handleoptionchange('surveytype')}
                renderInput={(params) => <TextField {...params} label={"Survey Type"} fullWidth margin="dense" variant="outlined" />}
              />}
            </Grid>


            <Grid
              item
              lg={12}
              md={12}
              sm={12}
              xs={12}
              spacing={2}
              style={{ display: "grid" }}
            >
              <Grid style={{ margin: "auto" }}>
                <input accept="image/*" className={classes.input} id="icon-button-file" type="file"
                  onChange={e => setData(e.target.files[0], "image", setValues, values)}
                />
                {values.imageurl ? <label htmlFor="icon-button-file">
                  <Avatar src={values.imageurl} style={{ width: 140, height: 140, borderRadius: 10, cursor: "pointer" }} />
                </label> : <label htmlFor="icon-button-file">
                  <Avatar src={values.imageurl} style={{ width: 140, height: 140, borderRadius: 10, cursor: "pointer" }} />
                </label>}
              </Grid>
            </Grid>
          </Grid>



        </div>
        <div className={classes.actions}>
          {/* <Button
            onClick={handleClear}
            variant="contained"
           
          >
            Clear
          </Button> */}
          {/* <Button
            color="primary"
            type="submit"
            variant="contained"
          >
            Update
          </Button> */}
        </div>
      </form>
    </Paper>
  );
};

AddSurvey.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
  onSave: PropTypes.func,
  open: PropTypes.bool.isRequired,
  masters: PropTypes.object
};

export default AddSurvey;
